import Vue from 'vue';
import Vuex from 'vuex'
import config from '@/config';

import task from 'firepuma-vue-axios-vuex-extensions/vuex-store/taskModule';

import auth from 'firepuma-vue-axios-vuex-extensions/vuex-keycloak/authModule';
import authConfig from 'firepuma-vue-axios-vuex-extensions/vuex-keycloak/config';

import alert from 'firepuma-vue-axios-vuex-extensions/vuex-errors/storeModule.js';

import broilerAdmin from '@/broilerAdmin/storeModule';

import grazing from '@/grazing/storeModule';

authConfig.Url = config.KeyCloak.Url;
authConfig.ClientId = config.KeyCloak.ClientId;
authConfig.Realm = config.KeyCloak.Realm;
authConfig.ExtraTokenFields = ['user_tenant'];

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,

  modules: {
    auth,
    task,
    alert,

    broilerAdmin,

    grazing,
  },

  state: {},

  getters: {
    appName: (state) => config.AppName,
    shortAppName: (state) => config.ShortAppName,
  },

  mutations: {},

  actions: {},
});

export const Store = store;



// WEBPACK FOOTER //
// ./src/store.js